'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = prepareData;

var _reactRelay = require('react-relay');

var _reactRelay2 = _interopRequireDefault(_reactRelay);

var _RelayContext = require('react-relay/lib/RelayContext');

var _RelayContext2 = _interopRequireDefault(_RelayContext);

var _toGraphQL = require('react-relay/lib/toGraphQL');

var _toGraphQL2 = _interopRequireDefault(_toGraphQL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prepareData(_ref) {
    var Component = _ref.Component;
    var route = _ref.route;

    return new _promise2.default(function (resolve, reject) {
        var relayContext = new _RelayContext2.default();
        var storeData = relayContext.getStoreData();

        storeData.getChangeEmitter().injectBatchingStrategy(function () {});

        var data = [];

        var handleQueryPayload = storeData.handleQueryPayload;
        storeData.handleQueryPayload = function (query, result, forceIndex) {
            data.push({ query: _toGraphQL2.default.Query(query), result: result });
            handleQueryPayload.call(storeData, query, result, forceIndex);
        };

        var querySet = _reactRelay2.default.getQueries(Component, route);

        relayContext.forceFetch(querySet, onReadyStateChange);

        function onReadyStateChange(_ref2) {
            var aborted = _ref2.aborted;
            var done = _ref2.done;
            var error = _ref2.error;
            var stale = _ref2.stale;

            if (error) {
                reject(error);
            } else if (aborted) {
                reject(new Error('Aborted'));
            } else if (done && !stale) {
                var props = {
                    Component: Component,
                    relayContext: relayContext,
                    route: route
                };
                resolve({ data: data, props: props });
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-relay/lib/prepareData.js
// module id = 1490
// module chunks = 0